import axios from 'axios'
import _ from 'lodash'
import { push } from 'connected-react-router'
import { Store } from 'redux'
import { notification } from 'antd'

import { LOGIN } from '../../routes'

export function applyAxiosInterceptors(store: Store) {
  axios.interceptors.response.use(undefined, (error: any) => {
    if (error.response && error.response.status === 401) {
      notification.error({
        message: 'Login Error',
        description: 'Credenziali errate.'
      })

      if (_.includes(_.get(error, 'request.responseURL', ''), '/login')) {
        return Promise.reject(error)
      }

      store.dispatch(push(LOGIN))
      return undefined
    }

    if (error.response && error.response.status === 403) {
      notification.error({
        message: 'Autorizzazione',
        description: 'Non sei autorizzato'
      })
    }

    return Promise.reject(error)
  })
}
